module.exports = __webpack_public_path__ + "static/img/g.c1702cf.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/g.png
// module id = 5Qqh
// module chunks = 1